import { render, staticRenderFns } from "./page11.vue?vue&type=template&id=be4e97e4"
import script from "./page11.vue?vue&type=script&lang=js"
export * from "./page11.vue?vue&type=script&lang=js"
import style0 from "./page11.vue?vue&type=style&index=0&id=be4e97e4&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports